import { C as ComponentFooter, d as defineCustomElement$1 } from './p-8bd1db02.js';
const OwcComponentFooter = ComponentFooter;
const defineCustomElement = defineCustomElement$1;
export { OwcComponentFooter, defineCustomElement };